'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_AppRouter$UserProfilePageApp$() {
}
export { $c_Lmealorama_AppRouter$UserProfilePageApp$ as $c_Lmealorama_AppRouter$UserProfilePageApp$ };
$p = $c_Lmealorama_AppRouter$UserProfilePageApp$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_AppRouter$UserProfilePageApp$;
/** @constructor */
function $h_Lmealorama_AppRouter$UserProfilePageApp$() {
}
export { $h_Lmealorama_AppRouter$UserProfilePageApp$ as $h_Lmealorama_AppRouter$UserProfilePageApp$ };
$h_Lmealorama_AppRouter$UserProfilePageApp$.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return (-436837388);
});
$p.m = (function() {
  return "UserProfilePageApp";
});
$p.q = (function() {
  return 0;
});
$p.r = (function() {
  return "UserProfilePageApp";
});
$p.g = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
});
var $d_Lmealorama_AppRouter$UserProfilePageApp$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_AppRouter$UserProfilePageApp$, "mealorama.AppRouter$UserProfilePageApp$", ({
  FA: 1,
  au: 1,
  b: 1,
  c: 1,
  a: 1,
  d: 1,
  e: 1,
  h: 1
}));
export { $d_Lmealorama_AppRouter$UserProfilePageApp$ as $d_Lmealorama_AppRouter$UserProfilePageApp$ };
var $n_Lmealorama_AppRouter$UserProfilePageApp$;
function $m_Lmealorama_AppRouter$UserProfilePageApp$() {
  if ((!$n_Lmealorama_AppRouter$UserProfilePageApp$)) {
    $n_Lmealorama_AppRouter$UserProfilePageApp$ = new $c_Lmealorama_AppRouter$UserProfilePageApp$();
  }
  return $n_Lmealorama_AppRouter$UserProfilePageApp$;
}
export { $m_Lmealorama_AppRouter$UserProfilePageApp$ as $m_Lmealorama_AppRouter$UserProfilePageApp$ };
//# sourceMappingURL=mealorama.-App-Router$-User-Profile-Page-App$.js.map
